import React from "react";

function SantaClara() {
  return (
    <div>
      {/* Second nav */}
      <nav className="navbar contact-nav navbar-light">
        <div className="container">
          <a
            className="navbar-brand d-flex align-items-center justify-content-center"
            href="./"
          >
            <img
              src="/assets/img/map-pin-loc.svg"
              alt="Map Pin"
              loading="lazy"
              width="100%"
            />
            <p className="location-head location-ca location-san">
              Santa Clara,CA
            </p>
            <p className="location-break">
              Santa Clara, <br />
              CA
            </p>
          </a>
          <div className="d-flex align-items-center" id="">
            <form className="nav-right contact-form-sec ms-auto d-flex align-items-center">
              <a className="nav-link call-us-link pe-0" href="tel:+14085397261">
                Call (408) 539-7261
              </a>
              <div className="d-flex">
                <a href="/book-online/">
                  <button className="btn sdl-btn" type="button">
                    SCHEDULE ONLINE
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar-check"
                      viewBox="0 0 16 16"
                    >
                      <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                    </svg>
                  </button>
                </a>
                <a href="/book-online/">
                  <button class="btn schedule-btn" type="button">
                    SCHEDULE
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar-check"
                      viewBox="0 0 16 16"
                    >
                      <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                    </svg>
                  </button>
                </a>
                <a href="tel:+14085397261">
                  <button className="btn call-us-btn" type="button">
                    Call
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-telephone-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                      />
                    </svg>
                  </button>
                </a>
              </div>
            </form>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default SantaClara;
